import basicController from "servicestack/basic.controller.properties";
import orderConfig from "emun.order/order.config";
import labels from "emun.order/_labels";
import ServiceBus from 'servicestack/service-bus'

export default class TrackingInfoController {
	constructor() {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.orderConfig = orderConfig;
		$ctrl.labels = labels;
		$ctrl.bus = new ServiceBus();
	}
	$onInit() {
		const $ctrl = this;
		$ctrl.bus.send('TrackShipment', {
			tracking_number: $ctrl.trackingNumber,
			carrier: $ctrl.carrier
		}).then(function (response) {
			$ctrl.tracking = response.data;
		});
	}
}